import { render, staticRenderFns } from "./SlideFilter.vue?vue&type=template&id=681966a8"
import script from "./SlideFilter.vue?vue&type=script&lang=js"
export * from "./SlideFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports